
















































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Contact } from '@/models/Contact';
import http from '@/services/Http';

declare var grecaptcha: any;

@Component
export default class ContactForm extends Vue {
    protected form: Contact;
    private showForm: boolean = true;
    private emailError: boolean = false;
    private errorMsg: string = '';
    private title: string;
    private text: '';
    private dataLayer = (window as any).dataLayer || [];
    private selectedOrgName = '';
    constructor() {
        super();
        this.form = {
            name: '',
            email: '',
            phone: '',
            city: '',
            message: '',
            newsletter: false,
            token: ''
        };
        this.selectedOrgName = this.$attrs['data-retailer-name'];
        this.title = this.$attrs['data-title'];
        this.text = JSON.parse(this.$attrs['data-text']);
    }

    private clearError() {
        this.emailError = false;
    }

    private submitForm() {
        this.errorMsg = '';
        this.emailError = false;
        const recaptchaSiteKey = (window as any).__litium.recaptchaSiteKey as string;

        if (!this.validateForm()) {
            return;
        } else {
            const submit = this.submit;
            grecaptcha.ready(function() {
                grecaptcha
                    .execute(recaptchaSiteKey, {
                        action: 'submit'
                    })
                    .then(function(token: string) {
                        submit(token);
                    });
            });
        }
    }

    private submit(token: string) {
        this.form.token = token;

        const contactForm = http.post(`/api/contactform`, this.form);
        contactForm.then((response: any) => {
            this.showForm = false;
            this.dataLayer.push({
                event: 'reseller-form',
                'reseller-formtype': 'contact',
                email: this.form.email,
                store: this.selectedOrgName,
                name: this.form.name,
                phoneNumber: this.form.phone,
                city: this.form.city,
                message: this.form.message
            });
        });
    }
    private validateForm(): boolean {
        const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
        if (this.form.email == '') {
            this.errorMsg = 'site.contactform.missingemail';
            this.emailError = true;
            return false;
        }
        if (!reg.test(this.form.email)) {
            this.errorMsg = 'site.contactform.emailincorrect';
            this.emailError = true;
            return false;
        }
        return true;
    }
}
